// Paytrie rotated its receiving wallets. When the order wallet field is
// auto-populated (e.g. from a reconnected wallet), a retired Paytrie address
// must never be used — substitute the current one. Matching is case-insensitive.
const OLD_EVM_WALLET = '0x5B5ECfc8122bA166b21d6Ea26268Ef97e09B2E9F'
const NEW_EVM_WALLET = '0xE37A107504C3140EaA9663954fbcD779607bC08E'
const OLD_SOLANA_WALLET = '5QR8fQxh6uZ3Gp7WnzRRHSt8FCsvRGRLpZys5V7TepRx'
const NEW_SOLANA_WALLET = 'AqkWsts4hNZx6urK2CZkNN1VuRfbdMrhgs2PiKP2i5Tm'

// Keyed by the retired address lowercased, so lookups are case-insensitive.
const LEGACY_PAYTRIE_WALLET_REPLACEMENTS: Record<string, string> = {
  [OLD_EVM_WALLET.toLowerCase()]: NEW_EVM_WALLET,
  [OLD_SOLANA_WALLET.toLowerCase()]: NEW_SOLANA_WALLET,
}

export const replaceLegacyPaytrieWallet = (address: string): string => {
  const replacement =
    LEGACY_PAYTRIE_WALLET_REPLACEMENTS[address.trim().toLowerCase()]
  return replacement ?? address
}
